// extracted by mini-css-extract-plugin
module.exports = {"print":"index_print__2kZbE"};